import * as React from "react";
import {cx} from "emotion";

import "./additional-options-panel.scss";

import {cs}             from "@Common/react/chain-services";
import {ellipsisMiddle} from "@Common/ui-components/heavy/common/design2/data-table/mobile/ellipsis-middle";
import {getNestedValue} from "@Common/utils/arr-path";
import {chain}          from "@Common/utils/fs";

import {AdditionalOptionsModal} from "./additional-options-modal/additional-options-modal";
import {coatingLabels}          from "./coating-labels";

export const AdditionalOptionsPanel = (
    {
        programPrefs,
        product,
        store,
        className,
        mailing,
        mailingLists,
        defaultUrl,
        coating,
    }
) => cs(
    () => (
        <div className={cx("additional-options-panel-4iw", className)}>

            <div className="header">
                <div className="label">
                    Additional Options
                </div>
                {cs(
                    ["modal", (_, next) => AdditionalOptionsModal({
                        programPrefs,
                        mailingLists,
                        product,
                        store,
                        mailing,
                        defaultUrl,
                        coating,
                        next,
                    })],
                    ({modal}) => (
                        <a
                            onClick={modal.show}
                        >
                            Edit
                        </a>
                    )
                )}
            </div>

            <div className="table">
                {(() => {
                    const StaticLine = ({label, value}) => (
                        <div className="line">
                            <div className="label">
                                {label}
                            </div>
                            <div className="value static">
                                {value}
                            </div>
                        </div>
                    );
                    return <>
                        {mailing && StaticLine({
                            label: "Mailing Class",
                            value: (() => {
                                const path = ["products", product, "options", "mailClassDefault"];
                                return getNestedValue(store.prefs, path) || getNestedValue(programPrefs, path) || "None";
                            })(),
                        })}
                        {coating && StaticLine({
                            label: "Coating Options",
                            value: (() => {
                                const path = ["products", product, "options", "defaultCoating"];
                                return chain(
                                    getNestedValue(store.prefs, path) || getNestedValue(programPrefs, path),
                                    (_) => !_ ? "None" : coatingLabels[_] ?? _,
                                );
                            })(),
                        })}

                        {mailing && (() => {
                            const path = ["defaultMailingList"];
                            const mls = getNestedValue(store.prefs, path);

                            return (
                                <div className="line">
                                    <div className="label">
                                        Default mailing List ({mls?.length ?? 0})
                                    </div>
                                    <div className="value ml">
                                        {mls?.length ? (
                                            mls?.map(({name, id}) => (
                                                <div className="ml" key={id}>
                                                    {ellipsisMiddle(name)}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="no-data">
                                                None
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })()}

                        {mailing && (() => {
                            const value = (
                                getNestedValue(store.prefs , ["prefData", "includeOrResident"]) ??
                                getNestedValue(programPrefs, ["programPreferences", "includeOrResident"])
                            );
                            return StaticLine({
                                label: "Include or Resident",
                                value: value ? "Yes" : "No",
                            });
                        })()}

                        {defaultUrl && (
                            StaticLine({
                                label: "Default URL",
                                value: (() => {
                                    const path = ["products", "socialMedia", "options", "defaultUrl"];
                                    return (
                                        getNestedValue(store.prefs , path) ||
                                        getNestedValue(programPrefs, path)
                                    );
                                })(),
                            })
                        )}
                    </>;
                })()}
            </div>
        </div>
    ),
);

